<template lang="pug">
  .control.readonly-input-controls
    BIcon.preview-mode-icon(
      v-if="!edit"
      @click.native="editActive()"
      icon="settings"
    )
    WtButton(v-if="edit" @click.native="update()" :disabled="disabled") UPDATE
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

/**
 * Icon and Button used for toggling readonly inputs
 * in preview mode
 */
export default {
  name: "WtReadonlyInputControls",

  components: { WtButton },

  props: {
    edit: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    editActive() {
      this.$emit("editActive", true);
    },

    update() {
      this.$emit("update");
    }
  }
};
</script>

<style lang="sass" scoped>
.readonly-input-controls
  .preview-mode-icon
    align-items: normal
    -webkit-transition: -webkit-transform .1s linear
          transition:         transform .1s linear
    &:hover
      color: black
      cursor: pointer
      -webkit-transform: rotate(3deg)
          transform: rotate(3deg)
</style>
